import React from "react";
import { useSelector} from "react-redux";
import { Link, withRouter } from "react-router-dom";
import { useRestaurant } from '../contexts/restaurant.context';
import { CART_ROUTE } from '../router/constants';

function CartFloatingButton({history}) {
    const restaurant = useRestaurant();

    const {theme} = restaurant;
    
    const isShowCartButton = useSelector(state => state.common.isShowCartButton);

    const isCartPath = window.location.pathname.startsWith(CART_ROUTE);
    
    const handlerGoBack = (e) => {
        // if (!prevHistory) { return false; }
        //
        // const {url, pageName} = prevHistory;
        // handlerGoToPage(e, url, pageName);
        history.goBack();
    };

    if (!isShowCartButton || !restaurant) {
        return null;
    }
    
    if (isCartPath) {
        return (
            <button type="button"
                    className="btn btn-cart floating d-xl-none"
                    onClick={handlerGoBack}
                    style={{
                        color: theme.floating_order_button_font_color,
                        backgroundColor: theme.floating_order_button_background_color,
                        borderColor: theme.floating_order_button_background_color,
                    }}
            >
                <i className="fas fa-angle-double-left"></i> Go Back
            </button>
        );
    }

    return (
        <Link
            to={CART_ROUTE}
            className="btn btn-cart floating d-xl-none"
            style={{
                color: theme.floating_order_button_font_color,
                backgroundColor: theme.floating_order_button_background_color,
                borderColor: theme.floating_order_button_background_color,
            }}
        >
            <i className="fas fa-shopping-cart"></i> View Order
        </Link>
    );
}

export default withRouter(CartFloatingButton);